import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-category-page',
  templateUrl: './category-page.component.html',
  styleUrls: ['./category-page.component.scss']
})
export class CategoryPageComponent implements OnInit{

  breadCrumbItems: Array<{}>;
  page = 'category';
  country = this.sharedService.selectedCmsCountryId;
  category = this.sharedService.selectedCmsCategoryId;
  countryList = this.sharedService.cmsCountryList;
  categoryList = this.sharedService.cmsCategoryList;

  constructor(private sharedService: SharedService, private router: Router, private route: ActivatedRoute) { }
  
  ngOnInit(){
    this.breadCrumbItems = [{ label: 'CMS' }, { label: 'Category Page', active: true }];
    if (this.countryList.length == 0) this.getCountriesList();
    if(this.country && this.categoryList.length==0) this.getCategories(this.country);
  }

  getCountriesList() {
    this.sharedService.getCmsCountryDetails().subscribe(
      (response: any) => {
        this.countryList = response;
        this.sharedService.cmsCountryList = this.countryList;
      })
  }

  selectCountry(country){
    this.sharedService.selectedCmsCountryId = country;
    this.sharedService.selectedCmsCategoryId = null;
    this.sharedService.cmsCategoryList = [];
    this.category = null;
    this.categoryList = [];

    this.sharedService.selectedCmsProductId = null;
    this.sharedService.cmsProductList = [];
    this.getCategories(country);
  }

  getCategories(country_id){
    this.sharedService.getCmsCategoryList(country_id).subscribe(
      (result:any)=>{
        this.categoryList = result;
        this.sharedService.cmsCategoryList = this.categoryList;
      })
  }

  selectCategory(category){
    this.sharedService.selectedCmsCategoryId = category;
    this.sharedService.cmsProductList = [];
    this.getProducts(category);
    const currentUrl = this.router.url;
    this.router.navigate([this.router.url]);
    this.router.navigateByUrl('/products/country', { skipLocationChange: true }).then(() =>
    this.router.navigateByUrl(currentUrl));
  }

  getProducts(category){
    this.sharedService.getCmsProductList(category).subscribe(
      (result:any)=>{
        this.sharedService.cmsProductList = result;
      })
  }

}
